module.exports = __webpack_public_path__ + "static/img/foto5.258ace7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photos/foto5.jpeg
// module id = l+bN
// module chunks = 0